import { ShieldedBalance } from "@components/Sappling/ShieldedBalance";

export const ShieldedBalanceToken = () => <ShieldedBalance hasSendButton />;
